/**
 * @generated SignedSource<<98271450bbf7169b16686a59033ca7ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BillCreateInput = {
  additionalDiscount: boolean;
  description?: string | null;
  expired: any;
  product: string;
  purchaserNumber: any;
  studentName: string;
  studentNumber: any;
  title: string;
};
export type BillCreateDialog_billCreateMutation$variables = {
  input: BillCreateInput;
};
export type BillCreateDialog_billCreateMutation$data = {
  readonly billCreate: {
    readonly id: string;
  };
};
export type BillCreateDialog_billCreateMutation = {
  response: BillCreateDialog_billCreateMutation$data;
  variables: BillCreateDialog_billCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Bill",
    "kind": "LinkedField",
    "name": "billCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BillCreateDialog_billCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BillCreateDialog_billCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "44aff9cc377e90a7cf23ae444dfb7b74",
    "id": null,
    "metadata": {},
    "name": "BillCreateDialog_billCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BillCreateDialog_billCreateMutation(\n  $input: BillCreateInput!\n) {\n  billCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa9d93d0e4dc5fca8ec4dae4f8dbd3e3";

export default node;
